import DeltaWifiGDAVenues, { ComponentDeltaWifiGDAVenuesUnderTest } from './DeltaWifiGDAVenues';

export default DeltaWifiGDAVenues;

export {
  ComponentDeltaWifiGDAVenuesUnderTest,
};
